<div class="ArticleListItem">
    <a [href]="article.link" class="ArticleLink ArticleListItem-linkOverlay" target="_blank"></a>
    <div class="ArticleListItem-content row">
        <div class="col-4 col-sm-3">
            <div class="Image">
                <img [src]="article.thumbnail" [alt]="article.title"/>
            </div>
        </div>
        <div class="col-8 col-sm-9">
            <div class="ArticleListItem-subtitle">
                <div class="ArticleListItem-label">
                    <div class="flush-top ArticleListItem-labelInner text-priority-3-light">{{ article.category }}</div>
                </div>
                <div class="ArticleListItem-timestamp Hide--desktop text-priority-3-light">{{ moment(article.date).format('MMM DD') }}</div>
            </div>
            <h4 class="ArticleListItem-title Hide--mobile text-priority-1-light">{{ article.title }}</h4>
            <h5 class="ArticleListItem-title Hide--desktop text-priority-1-light">{{ article.title }}</h5>
            <div class="ArticleListItem-description">
                <div class="space-tiny"></div>
                <div class="h6 text-priority-2-light">{{ article.subtitle }}</div>
                <div class="space-tiny"></div>
            </div>
            <div class="ArticleListItem-footer h6">
                <span class="ArticleListItem-footerTimestamp text-priority-3-light">{{ moment(article.date).format('YYYY.MM.DD') }}</span>
            </div>
        </div>
    </div>
</div>
